export default class BillerService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/billers/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/billers', params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/billers', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/billers/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/billers/' + id, params)
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('me/billers/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/BillerService.js